function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2C0 0.895431 0.895431 0 2 0H18C19.1046 0 20 0.895431 20 2V14C20 15.1046 19.1046 16 18 16H2C0.895431 16 0 15.1046 0 14V2Z",
  fill: "#E8A782"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.505 10.19C10.89 10.19 10.295 10.09 9.74 9.91C9.565 9.85 9.37 9.895 9.235 10.03L8.45 11.015C7.035 10.34 5.71 9.065 5.005 7.6L5.98 6.77C6.115 6.63 6.155 6.435 6.1 6.26C5.915 5.705 5.82 5.11 5.82 4.495C5.82 4.225 5.595 4 5.325 4H3.595C3.325 4 3 4.12 3 4.495C3 9.14 6.865 13 11.505 13C11.86 13 12 12.685 12 12.41V10.685C12 10.415 11.775 10.19 11.505 10.19Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14 2.56669C12.1047 2.56669 10.5666 4.10479 10.5666 6.00002C10.5666 7.89525 12.1047 9.43335 14 9.43335C15.8952 9.43335 17.4333 7.89525 17.4333 6.00002C17.4333 4.10479 15.8952 2.56669 14 2.56669ZM11.4333 6.00002C11.4333 4.58192 12.5819 3.43335 14 3.43335C14.5529 3.43335 15.0637 3.60867 15.4811 3.90749L11.9074 7.48113C11.6086 7.06378 11.4333 6.55293 11.4333 6.00002ZM14 8.56669C13.447 8.56669 12.9362 8.39137 12.5188 8.09255L16.0925 4.51891C16.3913 4.93626 16.5666 5.44711 16.5666 6.00002C16.5666 7.41812 15.4181 8.56669 14 8.56669Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.2
});

function SvgCallBarring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBarring);
export default __webpack_public_path__ + "static/media/call_barring.c1c80498.svg";
export { ForwardRef as ReactComponent };